import SectionHeader from "../components/common/SectionHeader";
import { useClosures, useTeam } from "../hooks/data";
import { fmtMoney, fmtRelative } from "../lib/format";
import { getEngine } from "../config/engines";
import { Trophy } from "lucide-react";
import { T } from "../lib/testids";

export default function Closures() {
  const { data: closures } = useClosures(100);
  const { data: team } = useTeam();

  const total = (closures || []).reduce((s, c) => s + c.closedValue.amount, 0);

  return (
    <div className="ambient-bg min-h-full">
      <div className="px-4 sm:px-8 pt-6 sm:pt-8 pb-4 sm:pb-6 border-b border-[#17223a]">
        <SectionHeader
          overline="Cierres"
          title="Ventas cerradas"
          subtitle="El resultado de tu trabajo comercial, convertido en ventas."
          right={
            <div className="text-right">
              <div className="text-[10px] font-mono uppercase tracking-[0.22em] text-zinc-500">
                Total periodo
              </div>
              <div className="font-display font-black text-3xl tabular-nums text-emerald-400 mt-1">
                {fmtMoney(total)}
              </div>
            </div>
          }
        />
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-[1fr_380px] min-h-[calc(100vh-260px)]">
        <div className="border-r border-[#17223a] overflow-x-auto">
          <table className="w-full text-xs" data-testid={T.closuresTable}>
            <thead>
              <tr className="text-left text-[9px] uppercase tracking-[0.2em] text-zinc-500 font-mono border-b border-[#17223a]">
                <th className="px-6 py-3 font-normal">Fecha</th>
                <th className="px-4 py-3 font-normal">Cuenta</th>
                <th className="px-4 py-3 font-normal">Categoría</th>
                <th className="px-4 py-3 font-normal">Cerrado por</th>
                <th className="px-6 py-3 font-normal text-right">Monto</th>
              </tr>
            </thead>
            <tbody>
              {(closures || []).length === 0 && (
                <tr>
                  <td colSpan={5} className="px-6 py-16 text-center text-zinc-500 font-mono text-[11px]">
                    Sin cierres registrados aún
                  </td>
                </tr>
              )}
              {(closures || []).map((c) => (
                <tr key={c.id} className="row-hover border-b border-[#101728]">
                  <td className="px-6 py-3 text-zinc-400 font-mono text-[11px]">
                    {fmtRelative(c.closedAt)}
                  </td>
                  <td className="px-4 py-3 text-zinc-100 font-medium max-w-[220px] truncate" title={c.companyName}>{c.companyName}</td>
                  <td className="px-4 py-3 text-zinc-400 font-mono text-[11px] uppercase tracking-[0.1em]">
                    {getEngine(c.engineId)?.humanLabel || c.engineId}
                  </td>
                  <td className="px-4 py-3 text-zinc-400">{c.closedByName || c.closedBy}</td>
                  <td className="px-6 py-3 text-right font-mono tabular-nums text-emerald-400">
                    {fmtMoney(c.closedValue.amount)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {team && team.length > 1 && (
          <aside className="bg-[#0d1321] p-6" data-testid={T.closuresTeamRanking}>
            <div className="flex items-center gap-2 text-[10px] font-mono uppercase tracking-[0.25em] text-zinc-500 mb-4">
              <Trophy size={12} className="text-amber-500" /> Ranking del mes
            </div>
            <div className="space-y-3">
              {team
                .slice()
                .sort((a, b) => b.monthClosedValue.amount - a.monthClosedValue.amount)
                .map((m, i) => (
                  <div key={m.id} className="flex items-center gap-3 border-b border-[#101728] pb-3 last:border-0">
                    <div className="w-6 h-6 border border-[#1b2846] flex items-center justify-center text-[10px] font-mono text-zinc-400 tabular-nums">
                      {i + 1}
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="text-sm text-zinc-100 truncate">{m.name}</div>
                      <div className="text-[10px] text-zinc-500 font-mono uppercase tracking-[0.15em]">
                        {m.monthClosuresCount} cierres
                      </div>
                    </div>
                    <div className="font-mono tabular-nums text-emerald-400 text-sm">
                      {fmtMoney(m.monthClosedValue.amount)}
                    </div>
                  </div>
                ))}
            </div>
          </aside>
        )}
      </div>
    </div>
  );
}
